import { PlayerGroup } from './../../../../../shared/sdk/models/PlayerGroup';
import { PlayerGroupApi } from './../../../../../shared/sdk/services/custom/PlayerGroup';
import { DataService } from './../../../../../core.module/services/data.service';
import { SelectItem } from 'primeng/primeng';
import { TransitionList } from './../rotationitem-listitem/transitionList.class';
import { CategoryRotationApi } from './../../../../../shared/sdk/services/custom/CategoryRotation';
import { ScheduleTimeframeApi } from './../../../../../shared/sdk/services/custom/ScheduleTimeframe';
import { CategoryRotation } from './../../../../../shared/sdk/models/CategoryRotation';
import { ScheduleTimeframe } from './../../../../../shared/sdk/models/ScheduleTimeframe';
import { RotationItemApi } from './../../../../../shared/sdk/services/custom/RotationItem';
import { ScreenApi } from './../../../../../shared/sdk/services/custom/Screen';
import { RotationItem } from './../../../../../shared/sdk/models/RotationItem';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { SortablejsOptions } from 'angular-sortablejs/dist';
import { ScreenCategory } from './../../../../../shared/sdk/models/ScreenCategory';
import { Screen } from './../../../../../shared/sdk/models/Screen';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataURLS } from '../../../../../shared/base.url';
import { LayoutPanel, LoopBackConfig } from '../../../../../shared/sdk';
import * as _ from 'lodash';

@Component({
  selector: 'app-screenorder-dialog',
  templateUrl: './screenorder-dialog.component.html',
  styleUrls: ['./screenorder-dialog.component.css']
})
export class ScreenorderDialogComponent implements OnInit {
  @ViewChild('inplaceDwellTime') inplaceDwellTime;
  public showAddScreenDialog: boolean;
  public transitionList = new TransitionList();
  public playerGroups: PlayerGroup[] = [];

  @Input() screenCategory: ScreenCategory;
  @Input() layoutPanel: LayoutPanel;
  @Input() categoryRotation: CategoryRotation; // used when a reference to the parent category rotatoin is needed, like in invokeTrigger()

  public draggingObject: any;
  public hasChange = false;

  public visibleVal: boolean;
  @Output() visibleChange = new EventEmitter();
  @Input()
  get visible() {
    return this.visibleVal;
  }

  set visible(val) {
    if (val) {
      // initilize on show
      this.getPlayerGroupList();
    }

    this.visibleVal = val;
    this.visibleChange.emit(this.visibleVal);
  }

  @Output() change = new EventEmitter();

  @Output() displayTriggerCode = new EventEmitter<RotationItem>();

  public defaultRotationSortableOptions: SortablejsOptions = {
    group: { name: 'screens', pull: true, put: false },
    sort: true,
    animation: 150,
    handle: '.drag-handle',
    onUpdate: (event: any) => {
      this.onUpdateRotationItemIndex(event);
    },
    onStart: (e) => {
      // evt.oldIndex;  // element index within parent
      const scToId = e.to.getAttribute('data-screencategoryid');
      const scFromId = e.from.getAttribute('data-screencategoryid');
      const fromRiId = e.item.getAttribute('data-rotationitemid');
      const fromRi = this.screenCategory.childRotationItems.find(ris => { return fromRiId === ris.id; });


      this.draggingObject = fromRi;
    },
    onRemove: (event: any) => {
      // this.onRemoveCategoryFromRotation(event);
    },
    onAddOriginal: (event: any) => {
      this.dragItemToCategoryRotation(event);
    },
    onMove: (e: any) => {
      // Example: http://jsbin.com/tuyafe/1/edit?js,output
      // event.dragged; // dragged HTMLElement
      // event.draggedRect; // TextRectangle {left, top, right и bottom}
      // event.related; // HTMLElement on which have guided
      // event.relatedRect; // TextRectangle
      // return false; — for cancel


      return true;

    }
  };


  // timeframe dialog vars
  public showTimeframeDialog: boolean;
  public currentTimeframe: ScheduleTimeframe;

  private currentTimeframeRotationItem: RotationItem;

  // condition editor
  public conditionEditorDialogVisible: boolean;
  public conditionRotationItem: RotationItem;

  constructor(
    public logger: LoggerService,
    public screenApi: ScreenApi,
    public rotationItemApi: RotationItemApi,
    public scheduleTimeframeApi: ScheduleTimeframeApi,
    public categoryRotationApi: CategoryRotationApi,
    public playerGroupApi: PlayerGroupApi,
    public dataService: DataService
  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);

  }

  ngOnInit() {

  }

  closeDialog() {

    this.visible = false;
  }

  async getPlayerGroupList() {
    try {

      const userId = this.dataService.getCalculatedUserId();

      const list = <PlayerGroup[]>await this.playerGroupApi.find({ where: { kanvasUserId: userId }, order: 'isSinglePlayerGroup ASC' }).toPromise();

      this.playerGroups = list;
      // this.playerGroupList.push({ label: allPlayerGroup.name, value: allPlayerGroup });

    } catch (error) {
      this.logger.error('could not load playerGroups for user', error);
    }

  }

  async dragItemToCategoryRotation(e) {
    const fromId = e.from.getAttribute('data-screencategoryid');
    const toId = e.to.getAttribute('data-screencategoryid');

    if (fromId !== toId) {
      e.item.remove();
    }

  }

  async onUpdateRotationItemIndex(e) {
    // set new position of rotation item
    const fromId = e.from.getAttribute('data-categoryRotationId');
    const toId = e.to.getAttribute('data-categoryRotationId');

    if (fromId !== toId) {
      e.item.remove();
    }

    // get the object we are currently dragging
    const ri = <RotationItem>this.draggingObject;


    // get the categroy rotation we are draging to
    const index = e.to.getAttribute('data-index');

    const rotationItems = this.screenCategory.childRotationItems;

    // update the local position
    this.move(this.screenCategory.childRotationItems, e.oldIndex, e.newIndex);

    try {
      // update position on server
      await this.rotationItemApi.setIndex(ri.id, e.newIndex).toPromise();

      this.hasChange = true;
    } catch (error) {
      this.logger.error('Error updating rotation item position', error);
    }
  }
  move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      let k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing purposes
  }



  // add screens to category (after selection)
  async addScreensToCategory(screens: Screen[]) {

    let index = this.screenCategory.childRotationItems.length;
    try {
      for (const scr of screens) {

        const ri = new RotationItem(); // create a new rotation item
        ri.screenId = scr.id;
        ri.ownerScreenCategoryId = this.screenCategory.id; // assign to current screen category
        ri.positionIndex = index;
        ri.dwellTime = scr.MinimumScheduleTime;

        if (!scr.isUniqueSchedule) {
          if (scr.rotationItems && scr.rotationItems.length) {
            const commonRi = scr.rotationItems[0];
            ri.dwellTime = commonRi.dwellTime;
            ri.transition = commonRi.transition;
            ri.scheduleTimeframes = _.cloneDeep(commonRi.scheduleTimeframes);
          }
        }

        const newRi = <any>await this.rotationItemApi.upsert(ri).toPromise();

        const newRiWithIncludes = await this.getRotationItemById(newRi.id);


        this.screenCategory.childRotationItems.push(newRiWithIncludes);


        index += 1;
      }

      this.hasChange = true;
      //  await this.updateTimelineParent();

    } catch (error) {
      this.logger.error('Error linking screen to category rotation', error);
    }
  }


  async getRotationItemById(id: string): Promise<RotationItem> {

    const newRiWithIncludes = <RotationItem>await this.rotationItemApi.findById(id, {
      include: [{
        'screenCategory': [
          { 'childRotationItems': [{ 'screen': 'playerGroups' }, 'scheduleTimeframes'] }
        ]
      }, { 'screen': 'playerGroups' }, 'scheduleTimeframes']
    }).toPromise();

    // make sure the arrays are initilized
    if (newRiWithIncludes && !newRiWithIncludes.scheduleTimeframes) { newRiWithIncludes.scheduleTimeframes = []; }
    if (newRiWithIncludes && newRiWithIncludes.screenCategory && !newRiWithIncludes.screenCategory.childRotationItems) { newRiWithIncludes.screenCategory.childRotationItems = []; }
    if (newRiWithIncludes && newRiWithIncludes.screen && !newRiWithIncludes.screen.playerGroups) { newRiWithIncludes.screen.playerGroups = []; }

    return newRiWithIncludes;
  }


  // timeframe editor
  openTimeframeDialog(timeframe: ScheduleTimeframe, rotationItem: RotationItem) {
    this.currentTimeframeRotationItem = rotationItem;

    if (timeframe) {
      this.currentTimeframe = _.cloneDeep(timeframe);
    } else {
      // create new timeframe with defaults
      this.currentTimeframe = null;
    }

    // display the dialog
    this.showTimeframeDialog = true;
  }

  async saveTimeframe(timeframe) {
    try {
      // set parent
      timeframe.rotationItemId = this.currentTimeframeRotationItem.id;

      // save timeframe
      const newTimeframe = <ScheduleTimeframe>await this.scheduleTimeframeApi.upsert(timeframe).toPromise();

      // show local copy on rotation item
      if (this.currentTimeframeRotationItem) { this.currentTimeframeRotationItem.scheduleTimeframes.push(newTimeframe); }

      this.showTimeframeDialog = false; // close editor after update

      this.hasChange = true;
    } catch (error) {
      this.logger.error('Error saving schedule timeframe', error);
    }

  }

  async removeTimeframe(timeframe: ScheduleTimeframe, rotationItem: RotationItem) {
    event.stopPropagation();  // will stop the click from passing to the timeframe div so the editor isn't opened

    try {
      // delete timeframe
      await this.scheduleTimeframeApi.deleteById(timeframe.id).toPromise();

      let index;

      index = rotationItem.scheduleTimeframes.findIndex(item => { return item.rotationItemId === rotationItem.id; });
      if (index !== -1) { rotationItem.scheduleTimeframes.splice(index, 1); } // remove item from list

      this.hasChange = true;
    } catch (error) {
      this.logger.error('Error deleting scheduletimeframe ', error);
    }

  }


  itemChanged() {
    this.hasChange = true;
  }

  checkForChangeOnHide() {
    if (this.hasChange) {
      this.change.emit(this.screenCategory);
      this.hasChange = false;
    }

  }

  async showTriggerCode(rotationItem) {
    this.displayTriggerCode.emit(rotationItem);
  }


  async displayConditionEditor(rotationItem: RotationItem) {
    // show dialog here
    this.conditionEditorDialogVisible = true;
    this.conditionRotationItem = rotationItem;
  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/screenorder-dialog/screenorder-dialog.component.ts